import storage from '@Ravnur-Inc/helpers/storage';

import { STORAGE_GROUP, STORAGE_TOKEN_KEY } from '../constants';

export function removeAuthToken() {
  storage.remove(STORAGE_GROUP, STORAGE_TOKEN_KEY);
}
